import { combineReducers } from 'redux-immutable'

import ribbonReducer from './components/Ribbon/reducer'
import workspaceReducer from './components/Workspace/reducer'
import navigationReducer from './components/Workspace/components/NavigationBar/reducer'

const rootReducer = combineReducers({
    ribbon: ribbonReducer,
    workspace: workspaceReducer,
    navigation: navigationReducer,
})

export default rootReducer
